import React from 'react';
import PropTypes from 'prop-types';
import { useLabels } from 'wsm-common-data';
import { sanitizeContent } from '../utils/utils';

export const DealerResponse = ({
	dealerName,
	dealerResponseDate,
	dealerResponseText
}) => {
	const labels = useLabels();
	return (
		<div className="rdc-review-response bg-contrast-med px-5 pb-5 pt-4">
			<div className="rdc-review-response-heading d-flex align-items-center">
				<h4 className="pr-3">
					{`${labels.get('RESPONSE_FROM')} ${dealerName}`}
				</h4>
				<span className="text-muted small">{dealerResponseDate}</span>
			</div>
			<div
				className="rdc-response-text"
				dangerouslySetInnerHTML={{
					__html: sanitizeContent(dealerResponseText)
				}}
			/>
		</div>
	);
};

DealerResponse.propTypes = {
	dealerName: PropTypes.string.isRequired,
	dealerResponseDate: PropTypes.string.isRequired,
	dealerResponseText: PropTypes.string.isRequired
};
